export default __webpack_public_path__ + "static/media/Poster-Jessica.c2217043.jpg";